/* Tiny Tree Light product page (port of templates/22-proj-beam/22.js onto Shopify).
   Bundles = quantity of the one variant (automatic discounts price 2/3 at checkout); add-ons are real products.
   Real cutoff countdown, live delivery timeline, sticky bar -> bottom sheet. Test dates with ?today=2026-12-06 */
(() => {
  const $ = (s, r = document) => r.querySelector(s), $$ = (s, r = document) => [...r.querySelectorAll(s)];
  const S = window.STORE, price = { 1: S.single, 2: S.pair, 3: S.triple };
  const money = n => "$" + (Math.round(n * 100) / 100).toFixed(2).replace(/\.00$/, "");
  const mainLadder = $("[data-ladder]"), sheetLadder = $("[data-sheet-ladder]"), adds = $("[data-adds]");
  let qty = +(($(".rung[aria-checked='true']", mainLadder) || { dataset: { qty: 2 } }).dataset.qty);

  /* ---------- running total; the add-on box lives inside the selected card only (keeps the button in the phone fold) ---------- */
  const addonsTotal = () => $$("[data-buybox] [data-addon]:checked").reduce((n, cb) => n + (+cb.dataset.price || 0) / 100, 0);
  const paint = () => {
    const total = money(price[qty] + addonsTotal());
    $$("[data-l22-total]").forEach(el => el.textContent = total);
    $$("[data-xp-qty]").forEach(el => el.value = qty);
    const saved = (S.compare || S.single) * qty - price[qty];
    $$("[data-l22-save]").forEach(el => { el.hidden = saved < 0.01; el.textContent = "You save " + money(saved); });
    if (sheetLadder) $$(".rung", sheetLadder).forEach(r => r.setAttribute("aria-checked", String(+r.dataset.qty === qty)));
    const sel = $(`.rung[data-qty='${qty}']`, mainLadder);
    if (adds && sel && adds.parentElement !== sel) sel.appendChild(adds);
  };
  $$(".rung", mainLadder).forEach(r => r.addEventListener("click", () => { $$(".rung", mainLadder).forEach(x => x.setAttribute("aria-checked", String(x === r))); qty = +r.dataset.qty; paint(); }));
  /* ticking an add-on must not re-trigger the card, and the card's keyboard radio keeps working */
  adds && adds.addEventListener("click", e => e.stopPropagation());
  $$(".rung", mainLadder).forEach(r => r.addEventListener("keydown", e => { if ((e.key === " " || e.key === "Enter") && e.target === r) { e.preventDefault(); r.click(); } }));
  if (sheetLadder) $$(".rung", sheetLadder).forEach(r => {
    const pick = () => { const twin = $(`.rung[data-qty='${r.dataset.qty}']`, mainLadder); twin && twin.click(); };
    r.addEventListener("click", pick);
    r.addEventListener("keydown", e => { if (e.key === " " || e.key === "Enter") { e.preventDefault(); pick(); } });
  });
  $$("[data-addon]").forEach(cb => cb.addEventListener("change", paint));

  /* ---------- gallery: thumbnails swap the image and its honesty caption ---------- */
  const main = $("[data-g-main]"), mainImg = main && $("img", main), cap = main && $("[data-cap]", main);
  $$("[data-g]").forEach(t => t.addEventListener("click", () => {
    $$("[data-g]").forEach(x => x.setAttribute("aria-current", "false")); t.setAttribute("aria-current", "true");
    const vid = $("[data-g-vid]", main);
    if (t.dataset.video && vid) {
      main.classList.add("has-video"); vid.poster = t.dataset.g; if (vid.getAttribute("src") !== t.dataset.video) vid.src = t.dataset.video;
      vid.play && vid.play().catch(() => {});
    } else {
      main.classList.remove("has-video"); vid && vid.pause && vid.pause();
      /* bundled assets are resized by the CDN (&width=), so the swapped image keeps a phone-sized file */
      const u = t.dataset.g, sep = u.includes("?") ? "&" : "?";
      if (u.includes("/assets/")) { mainImg.srcset = [480, 720, 960, 1200, 1600].map(w => `${u}${sep}width=${w} ${w}w`).join(", "); mainImg.src = `${u}${sep}width=1400`; }
      else { mainImg.removeAttribute("srcset"); mainImg.src = u; }
      mainImg.alt = t.dataset.alt || "";
    }
    if (cap) { cap.textContent = t.dataset.cap || ""; cap.hidden = !t.dataset.cap; }
  }));

  /* reduced motion: show the poster instead of the loop */
  if (window.matchMedia && matchMedia("(prefers-reduced-motion: reduce)").matches) { const v = $("[data-g-vid]"); if (v) { v.removeAttribute("autoplay"); v.pause && v.pause(); main && main.classList.remove("has-video"); } }

  /* ---------- bottom sheet ---------- */
  const sheet = $("[data-sheet]"), scrim = $("[data-sheet-scrim]");
  const openSheet = () => { paint(); sheet.classList.add("on"); scrim.classList.add("on"); sheet.setAttribute("aria-hidden", "false"); document.body.style.overflow = "hidden"; const f = $(".rung[aria-checked='true']", sheet); f && f.focus(); };
  const closeSheet = () => { sheet.classList.remove("on"); scrim.classList.remove("on"); sheet.setAttribute("aria-hidden", "true"); document.body.style.overflow = ""; };
  $$("[data-open-sheet]").forEach(b => b.addEventListener("click", openSheet));
  /* final band: pick 1/2/3, then open the bag sheet with that bundle selected */
  $$("[data-final-qty]").forEach(b => b.addEventListener("click", () => { const r = $(`.rung[data-qty='${b.dataset.finalQty}']`, mainLadder); r && r.click(); openSheet(); }));
  $$("[data-close-sheet]").forEach(b => b.addEventListener("click", closeSheet));
  scrim && scrim.addEventListener("click", closeSheet);
  document.addEventListener("keydown", e => { if (e.key === "Escape") closeSheet(); });
  $$("[data-sheet-atc]").forEach(b => b.addEventListener("click", () => { closeSheet(); addToBag($("[data-buybox] [data-atc]")); }));

  /* ---------- add to bag: qty of the one variant + each ticked add-on once ---------- */
  const addToBag = btn => {
    if (!window.TT || !S.variant) return;
    const items = [{ id: S.variant, quantity: qty }].concat($$("[data-buybox] [data-addon]:checked").map(cb => ({ id: +cb.dataset.addon, quantity: 1 })));
    $$("[data-atc-error]").forEach(el => el.hidden = true);
    btn && (btn.disabled = true);
    window.TT.add(items).finally(() => { btn && (btn.disabled = false); });
  };
  $$("[data-buybox] [data-atc]").forEach(b => b.addEventListener("click", () => addToBag(b)));

  /* the delivery timeline (Ordered / Ready / Delivered) is painted by tt-cart.js from the same order cutoff as the clock */

  paint();
})();
